import { StartCampaignOrAutomationPage } from "../../../externalComponents/StartCampaignOrAutomation";

const CreateCampaignFromScratchPage = () => {
  return <StartCampaignOrAutomationPage hasAutomations={true} />;
};

export default CreateCampaignFromScratchPage;